/**
 * Server-backed sound-mix config. The editor posts changes; the game reads
 * once at boot and applies the mix to GameAudio.
 */

export interface SoundConfig {
  /** 0..1 — scales every bus. */
  master: number;
  /** 0..1 — outside ambience loop + synth drone bed. */
  ambient: number;
  /** 0..1 — bite / death / pickup one-shots. */
  sfx: number;
}

export const SOUND_DEFAULTS: SoundConfig = {
  master: 1.0,
  ambient: 0.7,
  sfx: 0.8,
};

const API_URL = '/api/sound';
let cache: SoundConfig = { ...SOUND_DEFAULTS };

export async function loadSoundConfig(): Promise<SoundConfig> {
  try {
    const res = await fetch(API_URL, { cache: 'no-cache' });
    if (res.ok) {
      const j = await res.json();
      if (j && typeof j === 'object') {
        cache = { ...SOUND_DEFAULTS, ...(j as Partial<SoundConfig>) };
      }
    }
  } catch (err) {
    console.warn('loadSoundConfig failed:', err);
  }
  return cache;
}

export function getSoundConfig(): SoundConfig {
  return cache;
}

export async function saveSoundConfig(cfg: SoundConfig): Promise<void> {
  cache = cfg;
  const res = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cfg),
  });
  if (!res.ok) throw new Error(`POST /api/sound → ${res.status}`);
}
